import { render, staticRenderFns } from "./Chi_defaultItem.vue?vue&type=template&id=3f98dcf3&scoped=true"
import script from "./Chi_defaultItem.vue?vue&type=script&lang=ts"
export * from "./Chi_defaultItem.vue?vue&type=script&lang=ts"
import style0 from "./Chi_defaultItem.vue?vue&type=style&index=0&id=3f98dcf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98dcf3",
  null
  
)

export default component.exports